import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { TicPage } from '../pages/tic/tic.page'

const routes: Routes = [
  {
    path: '',
    data: {
      breadcrumb: 'Explore Taxability Codes',
    },
    component: TicPage,
  },
]

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicTicViewRoutesModule {}
